define(function (require) {
    "use strict";
    var BaseModel = require("models/BaseModel");

    var BannerModel = BaseModel.extend({
        defaults: {
            welcomeTitle: "",
            title: "",
            bannerContent: [],
            actionBtnText: "",
            actionBtnTooltip: ""
        },

        initialize: function (options) {
            this.welcomeTitle = options.welcomeTitle || "";
            this.title = options.title || "";
            this.bannerContent = options.bannerContent || [];
            this.actionBtnText = options.actionBtnText || "";
            this.actionBtnTooltip = options.actionBtnTooltip || "";
            this.spinnerText= options.spinnerText || "";
        }
    });

    return BannerModel;
});
